import { TBehavioralTimelineStepsItem } from 'types/behavioral-data';

export const getPercentage = (value: number, goal: number) => {
  const onePercent = goal / 100;
  const calculatedVal = Math.round(value / onePercent);
  return calculatedVal;
};

export const getTimeIntervalForCall = (period: string) => {
  switch (period) {
    case 'day':
      return 'hour';
    case 'week':
      return 'day';
    case 'month':
      return 'day';
    case 'year':
      return 'month';
    default:
      'day';
  }
};

export const getAverageStepsFromData = (arr: TBehavioralTimelineStepsItem[]) => {
  const average =
    arr.reduce((acc: any, entry: TBehavioralTimelineStepsItem) => acc + entry.value, 0) /
    arr.length;
  return average;
};

export const getSummaryStepsFromData = (arr: TBehavioralTimelineStepsItem[]) => {
  const summarySteps = arr.reduce((acc, entry: TBehavioralTimelineStepsItem) => {
    return acc + entry.value;
  }, 0);

  return summarySteps;
};

export const getSummaryStepsGoalFromData = (arr: TBehavioralTimelineStepsItem[]) => {
  const summaryGoal = arr.reduce((acc, entry: TBehavioralTimelineStepsItem) => {
    return acc + entry.goal;
  }, 0);
  return summaryGoal;
};

export const getRecordStepsFromData = (arr: TBehavioralTimelineStepsItem[]) => {
  const record = arr.reduce((prev, current) => {
    return prev.value > current.value ? prev : current;
  });

  return record;
};

export const CIRCLE_CHART_GRADIENT_LEVELS = [
  ['#F52B2B', '#F49034'],
  ['#F58D2B', '#F4E334'],
  ['#4BC370', '#8BFCD0'],
  ['#EAEBF0', '#EAEBF0'],
];
